/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-06-20 14:42:44
 * @LastEditors: 
 * @LastEditTime: 2022-06-20 14:52:05
 */
import Vue from 'vue';
export default{
  namespaced: true,
  state:{
    cardTypeObj:{},
    secondaryCardList:[],
    rechargeInfoObj:{}
  },
  getters:{
    
  },
  mutations:{
    setCardTypeInfo(state,data){
state.cardTypeObj=data
    },
    setSecondaryCardList(state,data){
state.secondaryCardList=data
    },
    spliceSecondaryCardItem(state,data){
state.secondaryCardList.splice(data,1)
    },
    setRechargeInfo(state,data){
state.rechargeInfoObj=data
    },
    
    
  },
  actions:{
    // ADD_COUNT ({ commit },data) {
    //   commit('addCount',data)
    // },
    
  }
}